module.exports = __webpack_public_path__ + "img/import-auto.f37a96ee.gif";